import { render, staticRenderFns } from "./EditClaimButton.vue?vue&type=template&id=409f4508"
import script from "./EditClaimButton.vue?vue&type=script&lang=ts"
export * from "./EditClaimButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports